export default "__VITE_ASSET__db04e716__"